import classNames from 'classnames'

import * as styles from './ListDivider.module.css'

function ListDivider({ className }) {
  const listDividerClassName = classNames(styles.divider, className)

  return <div className={listDividerClassName} />
}

export default ListDivider
